module.exports = __webpack_public_path__ + "media/promo/courses/images/media-eb90a0845164e92c72320bc038302bd0.png";